import { apiClient } from '@/lib/apiClient';

export interface ChatRoom {
  id: string;
  /** 'Support' is a helpdesk ticket rendered as a conversation — see SupportPanel. */
  type: 'Team' | 'Direct' | 'Support';
  title: string;
  otherUserId: string | null;
  lastMessageAt: string | null;
  lastMessagePreview: string | null;
  unreadCount: number;
}

export interface ChatMessage {
  id: string;
  senderId: string;
  senderName: string;
  body: string;
  createdAt: string;
  mine: boolean;
}

export interface ChatContact {
  userId: string;
  name: string;
  role: string;
}

export const getChatRooms = async () =>
  (await apiClient.get<ChatRoom[]>('/chat/rooms')).data;

export const getChatContacts = async () =>
  (await apiClient.get<ChatContact[]>('/chat/contacts')).data;

export const startDirectChat = async (userId: string) =>
  (await apiClient.post<{ roomId: string }>('/chat/direct', { userId })).data;

export const getChatMessages = async (roomId: string, before?: string) =>
  (await apiClient.get<ChatMessage[]>(`/chat/rooms/${roomId}/messages`, { params: before ? { before } : undefined })).data;

export const sendChatMessage = async (roomId: string, body: string) =>
  (await apiClient.post<ChatMessage>(`/chat/rooms/${roomId}/messages`, { body })).data;

export const markChatRead = (roomId: string) =>
  apiClient.post(`/chat/rooms/${roomId}/read`);
